import { render, staticRenderFns } from "./teacher-add-dialog.vue?vue&type=template&id=f0f7d830&scoped=true"
import script from "./teacher-add-dialog.vue?vue&type=script&lang=js"
export * from "./teacher-add-dialog.vue?vue&type=script&lang=js"
import style0 from "./teacher-add-dialog.vue?vue&type=style&index=0&id=f0f7d830&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f7d830",
  null
  
)

export default component.exports